export class EventTheme {
  theme_type: string= "THEME_TYPE001";
  theme_id: string = "THEME0001";
  primary_id: string = "PRIMARY0001";
  secondary_id: string = "SECONDARY0001";
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/event-theme.ts